import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NoticeFilterMsg from './noticeFilterMsg';
import NoProducts from './noProducts';
import { dispatchGetCommentCountBySkuId, dispatchProductsFollowStatus, dispatchQueryAdvertisement, dispatchQueryShopChat, dispatchQueryPrdPrice } from '../../../../store/search/actionCreator';
import styles from './index.module.scss';
import { filterType } from '../../../../utils/constants';
import ProductCard from './productCard';

const getSkuArry = (skuList = [], pageNum = 40) => {
  // const skuArry = [];
  // var num = Math.ceil(skuList.length / pageNum);
  // for (let i = 1; i <= num; i++) {
  //   const skuIds = []
  //   for (let j = (i - 1) * pageNum; j < i * pageNum; j++) {
  //     if (!skuList[j]) {
  //       continue
  //     } else {
  //       skuIds.push(skuList[j])
  //     }
  //   }
  //   if(skuIds.length !== 0){
  //     skuArry.push(skuIds)
  //   }
  // }
  // return skuArry
  if(skuList.length === 0) return skuList
  const num = Math.ceil(skuList.length / pageNum);
  const skuArry = [];
  for(let i = 0; i < num; i++){
    const start = i * pageNum;
    const end = start + pageNum;
    skuArry.push(skuList.slice(start, end))
  }
  return skuArry
}

function ProductsList() {
  const dispatch = useDispatch();

  const {
    products,
    allProductsIds,
    firstOfProductsIds,
    productsListStyle,
    urlParams,
    allData,
    comments,
    totalItem,
    shopChat
  } = useSelector(state => state.searchReducer);

  const {
    isLogin
  } = useSelector(state => state.commonReducer);


  useEffect(() => {
    if (allProductsIds.length) {
      const allProductsIdsArr = allProductsIds.split(',');
      const AD_productsIdsArr = allProductsIdsArr.map(item => `AD_${item}`);;
      const skuIdArr = allProductsIdsArr.map(item => ({ skuId: item }))
      const AD_skuArry = getSkuArry(AD_productsIdsArr);
      const skuArry = getSkuArry(skuIdArr, 30);
      if (AD_skuArry.length === 0 || skuArry.length === 0) return;
      // dispatch(dispatchQueryAdvertisement(AD_skuArry))
      dispatch(dispatchQueryPrdPrice(skuArry))
    }
  }, [allProductsIds])


  useEffect(() => {
    if (firstOfProductsIds.length) {
      dispatch(dispatchGetCommentCountBySkuId(JSON.stringify({ skuids: firstOfProductsIds })))
      dispatch(dispatchQueryShopChat({ pidList: firstOfProductsIds }))
    }
  }, [firstOfProductsIds])

  useEffect(() => {
    if(firstOfProductsIds.length){
      isLogin && allData.skuFallowPCSwitch === 'ON' && dispatch(dispatchProductsFollowStatus(firstOfProductsIds))
    }
  }, [isLogin, firstOfProductsIds, allData.skuFallowPCSwitch])

  const showComment = (skuId) => {
    const target = comments.filter(item => item.id == skuId);
    return target[0]?.countStr || 0;
  }

  const showShopChat = (skuId) => {
    const target = shopChat.filter(shop => shop.pid == skuId)[0];
    return target || {}
  }

  return (
    <div className={`${styles["goods-list"]} ${styles[productsListStyle]}`}>
      {
        !urlParams?.showMore && (urlParams?.sort !== undefined && urlParams.sort !== filterType.COMPREHENSIVE_SORT) && totalItem > 0 && <NoticeFilterMsg />
      }
      <ul className={`${styles["gl-warp"]} clearfix`}>
        {
          totalItem <= 0 ? <NoProducts /> : (
            products.map((item, index) => <ProductCard item={item} key={item.skuId} index={index} comment={showComment(item.skuId)} shopIcon={showShopChat(item.skuId)}/>)
          )
        }
      </ul>
    </div>
  )
}

export default ProductsList;